import { useState } from "react";

import styles from "./OrderTimeSelectionStep.module.scss";
import Button from "../support/Button";
import HeadingText from "../support/HeadingText";
import BodyText from "../support/BodyText";
import clsx from "clsx";
import moment from "moment";
import Card from "../card/Card";

export default function OrderTimeSelectionStep() {
  const [selectedDayIndex, setSelectedDayIndex] = useState<number>(0);

  const pickerDays = Array.from({ length: 7 }, (_, i) => {
    return [{ timestamp: moment().add(i, "days").valueOf() }];
  });

  function handleOnClickDay(dayIndex: number) {
    if (selectedDayIndex !== dayIndex) {
      setSelectedDayIndex(dayIndex);
    }
  }

  return (
    <Card>
      <div className={styles.modalBody}>
        <div className={styles.dayRow}>
          {pickerDays.map((pickerDay, index) => {
            const { timestamp } = pickerDay[0];
            const date = moment(timestamp);

            return (
              <Button
                variant="secondary"
                onClick={() => handleOnClickDay(index)}
                className={clsx({
                  [styles.selected]: selectedDayIndex === index,
                })}
                key={timestamp}
              >
                <div>
                  <HeadingText
                    as="p"
                    size="h3"
                    color="heading-1"
                    className={styles.capitalize}
                  >
                    {date.calendar({
                      sameDay: "dddd",
                      nextDay: "dddd",
                      nextWeek: "dddd",
                    })}
                  </HeadingText>
                  <BodyText as="span" color="body-1">
                    {date.format("MMM D")}
                  </BodyText>
                </div>
              </Button>
            );
          })}
        </div>
      </div>
    </Card>
  );
}
